import React, {Component} from 'react';
import {connect} from 'react-redux';
import {keyBy} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Header, Form, Grid, Radio, Button, Dropdown, Checkbox} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import ContainerTables from './ContainerTables';
import ImagePlaceholder from './ImagePlaceholder';
import DetailTable from './DetailTable';
import CombosTable from './CombosTable';
import FilesInvoiceHeader from './Header';
import './styles.scss';

class FilesInvoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeDocument': 'FC',
      'searchBy': 'FACTURA',
      'date': null,
      'selectItem': null,
      'invoice': null,
      'show': false,
      'showCombo': false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.FileInvoices, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.cleartInvoiceList();

    const propsFromRouter = this.props.location.state;
    if (propsFromRouter) {
      const {documentType, invoiceNumber, date} = propsFromRouter;
      const {invoiceList} = this.props;
      const invoiceData = invoiceList.find((inv) => inv.invoiceNumber === invoiceNumber);
      const period = invoiceData ? invoiceData.period : null;
      this.props.getInvoiceItem(invoiceNumber, {'period': period, 'type': documentType});
      this.setState({
        'selectItem': invoiceNumber,
        'typeDocument': documentType,
        'invoice': {
          'typeDocument': documentType,
          ...propsFromRouter,
        },
        'date': moment(date).toDate(),
        'show': true,
      });
    }
  }

  handleChange(field, value) {
    if (value) {
      this.setState({[field]: value, 'selectItem': null, 'show': false}, () => {
        this.handleSearch();
      });
    }
  }

  handleSelectDropdown(field, value) {
    const {optionsObject} = this.props;
    this.setState({[field]: value, 'invoice': {...optionsObject[value]}, 'show': false, 'showCombo': false});
  }

  handleSearch() {
    const {typeDocument, date, searchBy} = this.state;
    const {dealerId, agencyId, scope} = this.props;
    const dateFormat = moment(date).format(reverseShortDate);
    this.props.getInvoicesList(dateFormat, typeDocument, {searchBy, dealerId, agencyId, scope});
  }

  handleCombos(value) {
    this.setState({'showCombo': value}, () => this.handleSubmit());
  }
  
  handleSubmit() {
    const {selectItem, typeDocument, showCombo} = this.state;
    const {invoiceList} = this.props;
    const invoiceData = invoiceList.find((inv) => inv.invoiceNumber === selectItem);
    const period = invoiceData ? invoiceData.period : null;
    if (showCombo) {
      this.props.getInvoiceCombos(selectItem, typeDocument);
    } else {
      this.props.getInvoiceItem(selectItem, {'period': period, 'type': typeDocument});
    }
    this.setState({'show': true});
  }

  renderList({searchBy, loading, optionsInvoice = [], optionsChasis = []}) {
    if (loading) {
      return [];
    }
    if (searchBy === 'FACTURA') {
      return optionsInvoice;
    } else if (searchBy !== 'FACTURA') {
      return optionsChasis;
    }
    return [];
  }
  
  render() {
    const {typeDocument, searchBy, date, selectItem, invoice, show, showCombo} = this.state;
    const {loading, optionsInvoice, optionsChasis, invoicesItem, loadingItem, invoicesCombos} = this.props;

    return (
      <div>
        <FilesInvoiceHeader
          show={show}
          invoice={invoice}
          showCombo={showCombo}
          invoicesItem={invoicesItem}
          invoicesCombos={invoicesCombos}
          addMessageBoxError={this.props.addMessageBoxError}
        />
        <Card raised fluid>
          <div className='file-invoices-padding'>
            <Header as='h4'>Parámetros de Búsqueda</Header>
            <Form onSubmit={this.handleSubmit}>
              <Grid columns={6} divided>
                <Grid.Column>
                  <Form.Input inline className='invoice-mt-label' label='Fecha'>
                    <DatePicker
                      locale='es'
                      placeholderText='Selección de fecha'
                      className='tcc-datepicker'
                      showYearDropdown
                      selected={date}
                      disabled={loading}
                      maxDate={moment().toDate()}
                      dateFormat={dateFormatPicker}
                      onChange={(value) => this.handleChange('date', value)}
                    />
                  </Form.Input>
                </Grid.Column>
                <Grid.Column>
                  <label className='invoice-b-10'>Tipo de Documento</label>
                  <Form.Group inline>
                    <div>
                      <Form.Field
                        control={Radio}
                        label='Factura'
                        value='FC'
                        disabled={loading || !date}
                        checked={typeDocument === 'FC'}
                        onChange={(e, {value}) => this.handleChange('typeDocument', value)}
                      />
                      <Form.Field
                        control={Radio}
                        disabled={loading || !date}
                        label='Nota de Crédito'
                        value='DC'
                        checked={typeDocument === 'DC'}
                        onChange={(e, {value}) => this.handleChange('typeDocument', value)}
                      />
                    </div>
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <label className='invoice-b-10'>Búsqueda por</label>
                  <Form.Group inline>
                    <div>
                      <Form.Field
                        disabled={loading || !date}
                        control={Radio}
                        label={
                          typeDocument === 'FC' ?
                            'No. Factura' :
                            'Nota de Crédito'
                        }
                        value='FACTURA'
                        checked={searchBy === 'FACTURA'}
                        onChange={(e, {value}) => this.handleChange('searchBy', value)}
                      />
                      <Form.Field
                        disabled={loading || !date}
                        control={Radio}
                        label='Chassis'
                        value='CHASSIS'
                        checked={searchBy === 'CHASSIS'}
                        onChange={(e, {value}) => this.handleChange('searchBy', value)}
                      />
                    </div>
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group inline className='invoice-mt-custom'>
                    <Dropdown
                      search
                      noResultsMessage='No hay resultados'
                      placeholder='Buscar'
                      fluid
                      loading={loading}
                      selection
                      disabled={loading}
                      onChange={(e, {value}) => this.handleSelectDropdown('selectItem', value)}
                      options={this.renderList({
                        searchBy,
                        loading,
                        optionsInvoice,
                        optionsChasis,
                      })}
                    />
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <Form.Group inline>
                    <div className='invoice-mt-custom-ck'>
                      <Checkbox
                        label='Ver Combos'
                        checked={showCombo}
                        disabled={!selectItem}
                        onChange={(e, {checked}) => this.handleCombos(checked)}
                      />
                    </div>
                  </Form.Group>
                </Grid.Column>
                <Grid.Column>
                  <div
                    className='invoice-mt-custom'
                    style={{'display': 'flex', 'justifyContent': 'center'}}
                  >
                    <Button disabled={!selectItem} type='submit' color='black'>
                      BUSCAR
                    </Button>
                  </div>
                </Grid.Column>
              </Grid>
            </Form>
          </div>
        </Card>
        {show ? (
          <Card raised fluid>
            <div className='file-invoices-padding'>
              <Header as='h3'>
                {' '}
                Detalle de {showCombo ? 'los Combos' : 'la factura'}
              </Header>
              <ContainerTables loading={loadingItem}>
                {showCombo ? (
                  <CombosTable items={invoicesCombos} />
                ) : (
                  <DetailTable items={invoicesItem} invoice={invoice} />
                )}
              </ContainerTables>
            </div>
          </Card>
        ) : (
          <ImagePlaceholder typeDocument={typeDocument} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {permissions, isUserFromTDE} = state.session;
  const optionsInvoice = state.partInvoices.invoicesList.map((item, idx) => ({
    'key': idx,
    'text': ` ${item.serial}-${item.physicalNumber}`,
    'value': item.invoiceNumber,
    'fac': item,
  }));
  const optionsChasis = state.partInvoices.invoicesList.map((item) => ({
    'key': `${item.invoiceNumber}-${item.physicalNumber}-${item.chassis}`,
    'text': `${item.chassis}`,
    'value': item.invoiceNumber,
  }));
  let searchScope = false;
  const permission = permissions.find((item) => item.rsname === 'Facturación Electrónica');
  if (permission) {
    searchScope = permission.scopes.includes(scopes.PartialSee);
  }
  const optionsObject = keyBy(state.partInvoices.invoicesList, 'invoiceNumber');
  return {
    'permissions': state.session.permissions,
    'loading': state.partInvoices.loading,
    'loadingItem': state.partInvoices.loadingItem,
    'invoicesItem': state.partInvoices.invoicesItem,
    'invoicesCombos': state.partInvoices.invoicesCombos,
    'invoiceList': state.partInvoices.invoicesList,
    optionsInvoice,
    optionsChasis,
    optionsObject,
    'dealerId': state.session.dealerId,
    'agencyId': state.session.dealerAgency,
    'scope': searchScope || isUserFromTDE ? 'allAgencies' : 'agency',
    'push': ownProps.history.push,
    'location': ownProps.history.location,
  };
};

const {
  getInvoicesList,
  getInvoiceItem,
  cleartInvoiceList,
  getInvoiceCombos,
  addMessageBoxError,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  getInvoicesList,
  getInvoiceItem,
  getInvoiceCombos,
  cleartInvoiceList,
  addMessageBoxError,
})(FilesInvoices));
